import React from 'react';
import { useLocation } from 'react-router-dom';
import { useConfiguration } from '../../context/configurationContext';
import loadable from '@loadable/component';
import ExploreDestinations from '../../components/ExploreDestinations/ExploreDestinations';

const SectionBuilder = loadable(
  () => import(/* webpackChunkName: "SectionBuilder" */ '../PageBuilder/PageBuilder'),
  {
    resolveComponent: components => components.SectionBuilder,
  }
);



const FooterComponent = () => {
  const { footer = {}, topbar } = useConfiguration();
  const location = useLocation();

  // If footer asset is not set, let's not render Footer at all.
  if (Object.keys(footer).length === 0) {
    return null;
  }

  // Paths where ExploreDestinations should not be shown
  const hideExploreDestinations = [
    '/inbox',
    '/listings',
    '/profile-settings',
    '/account',
    '/shop',
  ].some(path => location.pathname.startsWith(path));

  // The footer asset does not specify sectionId or sectionType. However, the SectionBuilder
  // expects sectionId and sectionType in order to identify the section. We add those
  // attributes here before passing the asset to SectionBuilder.
  const footerSection = {
    ...footer,
    sectionId: 'footer',
    sectionType: 'footer',
    linkLogoToExternalSite: topbar?.logoLink,
  };

  return (
    <>
      {!hideExploreDestinations && <ExploreDestinations />}
      <SectionBuilder sections={[footerSection]} />
    </>
  );
};

// NOTE: if you want to add dynamic data to FooterComponent,
//       you could just connect this FooterContainer to Redux Store
//
// const mapStateToProps = state => {
//   const { currentUser } = state.user;
//   return { currentUser };
// };
// const FooterContainer = compose(connect(mapStateToProps))(FooterComponent);
// export default FooterContainer;

export default FooterComponent;

